import { useEffect, useCallback, useLayoutEffect } from 'react';
import { useAnimationContext, useAnimationHandlersContext } from '../../../context/useAnimationContext';
import { useAddAnimationClasses } from '../../../context/useAddAnimationClasses';
import { ROUND_ICONS, ANIMATE_ON_OPEN, PORTRAIT_BACKGROUND, CONTAINER, BACKGROUND } from '../../../context/constants';
import { useDeviceSelector } from 'js/store/hooks';
import { pick } from 'ramda';
import { useDelayedCallback } from '../useDelayedCallback';
import { useIsMounted } from 'js/hooks/useIsMounted';

export const useAddAnimateOnOpenClass = (callback?: () => void) => {
    const { shouldAnimateOnOpen, isPrevAnimationEndMap } = useAnimationContext();
    const { isPortrait } = useDeviceSelector(pick(['isPortrait']));
    const isMounted = useIsMounted();

    const {
        resetAnimateOnOpen,
        handleSetAnimationClasses,
        handleRemoveContainerClasses,
        handleSetContainerClasses
    } = useAnimationHandlersContext();

    const {
        currentClassesMap,
        handleSetClassesMap
    } = useAddAnimationClasses();

    const removeAnimationClasses = useCallback(
        () => {
            if (!isMounted()) {
                return;
            }
            handleRemoveContainerClasses(ANIMATE_ON_OPEN);
        },
        [handleRemoveContainerClasses, isMounted]
    );

    const delayedRemove = useDelayedCallback(removeAnimationClasses, 600);

    useLayoutEffect(() => {
        if (!shouldAnimateOnOpen) {
            delayedRemove();
            resetAnimateOnOpen();
        }

        if (shouldAnimateOnOpen) {
            handleSetContainerClasses(ANIMATE_ON_OPEN);

            if (isPrevAnimationEndMap[CONTAINER]) {
                handleSetClassesMap[PORTRAIT_BACKGROUND]?.();

                if (!isPortrait) {
                    handleSetClassesMap[ROUND_ICONS]?.();
                    callback?.();
                    resetAnimateOnOpen();
                }
            }

            if (isPrevAnimationEndMap[BACKGROUND] && isPortrait) {
                handleSetClassesMap[ROUND_ICONS]?.();
                callback?.();
                resetAnimateOnOpen();
            }
        }
    }, [
        handleSetClassesMap,
        resetAnimateOnOpen,
        isPrevAnimationEndMap,
        shouldAnimateOnOpen,
        callback,
        delayedRemove,
        handleSetContainerClasses,
        isPortrait,
        removeAnimationClasses
    ]);

    useEffect(() => {
        handleSetAnimationClasses(ANIMATE_ON_OPEN, currentClassesMap);
    }, [currentClassesMap, handleSetAnimationClasses, shouldAnimateOnOpen]);

    return { currentClasses: currentClassesMap };
};
